// MyGarage Feature

// Add show/hide to buttons w/triggers
function modelTrigger(value) {
  const modals = Array.from(document.getElementsByClassName(value));
  for (let i = 0; i < modals.length; i++) {
    if (modals[i].style.display === "none") {
      modals[i].style.display = "block";
    } else {
      modals[i].style.display = "none";
    }
  }
}

// Parse Cookies when required
function parseCookieString(cookieString) {
  return cookieString.split(";").reduce(function (cookieObject, cookie) {
    let parts = cookie.split("=");
    cookieObject[parts.shift().trim()] = decodeURI(parts.join("="));
    return cookieObject;
  }, {});
}

// Add Vehicle
function handleSubmit(event) {
  event.preventDefault();

  const selectMake = document.getElementById("makeDropdown");
  const selectModel = document.getElementById("modelDropdown");
  const valueToAdd = `${selectMake.value} ${selectModel.value}`;
  console.log("Trigger Event: " + valueToAdd);

  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject.myGarage || "[]");
  let valueExistsInGarage = myGarageArray.includes(valueToAdd);
  if (!valueExistsInGarage) {
    myGarageArray.push(valueToAdd);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      "myGarage=" +
      JSON.stringify(myGarageArray) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
  }
  refreshCookieArray();
  filterGarageItem(valueToAdd);
}

function addVehicle(value) {
  const valueToAdd = value;
  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject.myGarage || "[]");
  let valueExistsInGarage = myGarageArray.includes(valueToAdd);
  if (!valueExistsInGarage) {
    myGarageArray.push(valueToAdd);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      "myGarage=" +
      JSON.stringify(myGarageArray) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
  }
  filterGarageItem(valueToAdd);
  refreshCookieArray();
}

// Make a Filter Active
function filterGarageItem(value) {
  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject?.myActiveGarage ?? "[]");
  let valueExistsInGarage = myGarageArray.includes(value);
  var targetFilter = document.querySelector(
    `.vehicle-compatibility-content .checkbox[value="${value}"]`
  );
  if (!valueExistsInGarage) {
    myGarageArray = ["" + value + ""];
    refreshLinks(value);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      "myActiveGarage=" +
      JSON.stringify(myGarageArray) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
    document.getElementById("modelBackup").click();
  } else {
    myGarageArray = [];
    refreshLinks(value);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      "myActiveGarage=" +
      JSON.stringify(myGarageArray) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
      if (document.getElementById("clearAll") !== null){
      document.getElementById("clearAll").click();
      } else {
      document.getElementById("modelBackup").href ="?sort_by=best-selling";
      document.getElementById("modelBackup").click();
      }
  }
}

// Refresh Links on the page to reflect current filter
function refreshLinks(value) {
  const menuItems = document.querySelectorAll(
    '.header__linklist-item[data-item-title="SHOP BY CATEGORY"] a, .header__linklist-item[data-item-title="SHOP BY PRODUCTS"] a, .vehicle-filter-links'
  );
  let url = new URL(window.location.href);
  let searchParams = url.searchParams;
  value1 = value.toString().replace(/ /g, "+");
  var urlValue = `?filter.p.m.vehicle.compatibility=${value1}`;

  if (urlValue == "?filter.p.m.vehicle.compatibility=") {
    var urlValue = ``;
    document.getElementById("shopby-message").style.opacity = "0";
    document.getElementById("shopby-message").innerHTML = `No car selected. Select a car from your garage to shop by vehicle.`;
    document.getElementById("garageselection").innerHTML = `<h3>My Garage</h3><h4>Start by adding your vehicle below.</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" />`;
  } else {
    document.getElementById("shopby-message").style.opacity = "1";
    document.getElementById("shopby-message").innerHTML = `Now shopping for <span style="font-weight: 500;">${value}</span> products.`;
    document.getElementById("garageselection").innerHTML = `<h3>Now shopping for</h3><h4>${value}</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" />`;
    document.getElementById("garageselection").style.backgroundColor = "#bcffc6";
    searchParams.forEach((value1, key) => {
      if (
        key == "filter.v.price.lte" ||
        key == "filter.v.price.gte" ||
        key == "sort_by" ||
        key == "filter.p.tag"
      ) {
        urlValue = `${urlValue}&${key}=${value1}`;
      }
    });
  }

  (menuItems ?? []).forEach((a) => {
    if (a.href.includes("#")) {
      return;
    }
    let inurl = new URL(a.href);
    inurl.search = "";
    a.href = inurl.href + urlValue;
  });

  document.getElementById("modelBackup").href = urlValue;
}

// Apply Active Class
function activeGarageItem(value) {
  // If Parameters are applied, double check they exist in the garage first.
    let compatValue = new URLSearchParams(window.location.search)?.get('filter.p.m.vehicle.compatibility');
    console.log(compatValue);
    if (compatValue && compatValue !== null){
    if (value && value.includes(compatValue)){
    console.log('Boom! ' + compatValue + ' is in your garage. Continue.. ');
    } else {
    console.log('Uh Oh, New Vehicle. Not in Garage. Revert. REVERT!');
    var clearAll = document.createElement("div");
    var garageSelection = document.getElementById("garageselection");
    clearAll.innerHTML = `<div style="padding-bottom:18px;" class="myGarageOptions">
    <button style="border: 1px solid #fff;" class="myGarageItem button button--secondary" onclick="addVehicle('${compatValue}');">Add to Garage</button>
    <a style="border: 1px solid #fff;" class="myGarageItem button button--ternary" style="display: flex;" href="?sort_by=" data-action="clear-filters">Clear Filter</a>
  </div>`;
    garageSelection.after(clearAll);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie = "myActiveGarage=[]; expires=" + expiryDate.toUTCString() + "; path=/";
    refreshLinks(compatValue);
    return;
    }
    }
  // In garage? Boom! Continue.
  if (
    document.cookie
      .split(";")
      .some((item) => item.trim().startsWith("myActiveGarage="))
  ) {
    // Get all elements with class "myClass"
    var inputs = document.querySelectorAll(
      ".vehicle-compatibility-content input"
    );
    // Create an empty array to store the values
    var vehicleCompatFilters = [];
    // Loop through the elements and add their values to the array
    // Loop through the input elements and add their values to the array
    for (var i = 0; i < inputs.length; i++) {
      // Only add the value if the input is not a button or submit type
      if (inputs[i].type !== "button" && inputs[i].type !== "submit") {
        vehicleCompatFilters.push(inputs[i].value);
      }
    }    
    // Check if the cookie exists
    let cookieObject = parseCookieString(document.cookie);
    let myActiveGarageArray = JSON.parse(cookieObject.myActiveGarage ?? "[]");

    // Is the compatible vehicle set and in garage, but not active? Lets make it active.
    if (compatValue !== null && myActiveGarageArray.toString() !== compatValue){
      console.log('In garage but is not an active filter. Lets do this. URL: ' + compatValue + ' FilterArray ' + myActiveGarageArray);
      filterGarageItem(compatValue);
      return;
    }

    refreshLinks(myActiveGarageArray);
    if (value == null) {
      document.getElementById("shopby-message").style.opacity = "0";
      document.getElementById("shopby-message").innerHTML = `Use MyGarage to filter our store.`;
      document.getElementById("mygarage-intro").innerHTML = `<div class="garageselection"><h3>My Garage</h3><h4>Start by adding your vehicle below.</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" /></div>`;
    } else {
      value.forEach(function (values) {
        var targetElement = document.querySelector(
          `.myGarageItem[data-value="${values}"]`
        );
        if (myActiveGarageArray == values) {
          
          var targetElement = document.querySelector(
            `.myGarageItem[data-value="${myActiveGarageArray}"]`
          );
          targetElement.classList.add("active");
          console.log(
            `Vehicle ${myActiveGarageArray} is currently filtered from your Garage.`
          );
        } else
        // Update the HTML list with the contents of the array
        if (vehicleCompatFilters.includes(values)) {
        } else {
          console.log(
            `Vehicle ${values} has no products on this page. Make Inactive.`
          );
          targetElement.classList.add("inactive");
          targetElement.innerHTML = "(0) " + targetElement.innerHTML;
        }
      });
    }
  }
}

// Remove a Vehicle
function removeGarageItem(value) {
  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject.myGarage || "[]");
  let myActiveGarageArray = JSON.parse(cookieObject.myActiveGarage || "[]");

  let needReset = false;
  if (myActiveGarageArray.includes(value)) {
    needReset = true;
  }

  let indexGarage = myGarageArray.indexOf(value);
  if (indexGarage > -1) {
    myGarageArray.splice(indexGarage, 1);
  }
  let indexActive = myActiveGarageArray.indexOf(value);
  if (indexActive > -1) {
    myActiveGarageArray.splice(indexActive, 1);
  }

  let expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 365);
  document.cookie =
    "myGarage=" +
    JSON.stringify(myGarageArray) +
    "; expires=" +
    expiryDate.toUTCString() +
    "; path=/";
  document.cookie =
    "myActiveGarage=" +
    JSON.stringify(myActiveGarageArray) +
    "; expires=" +
    expiryDate.toUTCString() +
    "; path=/";

  if (needReset === true) {
    let reset = document.getElementById("clearAll");
    reset.click();
  } else {
    refreshCookieArray();
  }
}

// Refresh and Rebuild
function refreshCookieArray() {
  let cookieObject = parseCookieString(document.cookie);
  if (
    document.cookie
      .split(";")
      .some((item) => item.trim().startsWith("myGarage="))
  ) {
    let myGarageArray = JSON.parse(cookieObject.myGarage || "[]");
    if (myGarageArray.toString() === "" || myGarageArray.toString() === null) {
      let listHTML = `<div id="garageselection"><h3>My Garage</h3><h4>Start by adding your vehicle below.</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" /></div>`;
      document.getElementById("myGarageList").innerHTML = listHTML;
      document.getElementById("editGarage").style.display = "none";
      activeGarageItem(myGarageArray);
    } else {
      let listHTML = `<div id="garageselection"></div>`;
          
      myGarageArray.forEach(function (item) {
        item_code = "'" + item + "'";
        listHTML += `<div class="myGarage"><button class="myGarageItem button button--ternary button--full" data-value="${item}" onclick="filterGarageItem(${item_code})"><span class="myGarageItemName">${item}</span><span></span></button><button style="display:none;" class="myGarageRemoval" onclick="removeGarageItem(${item_code})">x</button></div>`;
      });
      document.getElementById("myGarageList").innerHTML = listHTML;
      document.getElementById("editGarage").style.display = "flex";
      activeGarageItem(myGarageArray);
    }
  } else {
    let myGarageArray;
    let listHTML = `<div id="garageselection"><h3>My Garage</h3><h4>Start by adding your vehicle below.</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" /></div>`;
      document.getElementById("myGarageList").innerHTML = listHTML;
      document.getElementById("editGarage").style.display = "none";
      activeGarageItem(myGarageArray);
  }
}

// List all them sexy models
const carModels = {
  UNIVERSAL: ["FIT"],
  NISSAN: [
    "S13 KA24 240SX",
    "S13 SR20 240SX/SILVIA",
    "S13 KA24 HATCH",
    "S13 SR20 240SX HATCH",
    "S14 240SX/SILVIA",
    "S15 SILVIA",
    "R32 SKYLINE GTS-T",
    "R32 SKYLINE GTS4",
    "R32 SKYLINE GTR",
    "R33 SKYLINE GTS",
    "R33 SKYLINE GTS-T",
    "R33 SKYLINE GTS4",
    "R33 SKYLINE GTR",
    "R34 SKYLINE GT",
    "R34 SKYLINE GT-T",
    "R34 SKYLINE GTR",
    "RZ34 Z",
    "WGNC34 STAGEA",
    "Z33 350Z",
    "Z34 370Z",
    "Z32 300ZX",
    "C33 Laurel",
    "C34 Laurel",
    "C35 Laurel",
    "CEFIRO A31",
  ],
  INFINITI: [
    "G35",
    "G37",
  ],
  SUBARU: [
    "BRZ ZC6",
    "BRZ ZD8",
    "IMPREZA GE/GH",
    "IMPREZA GP/GJ",
    "IMPREZA GK/GT",
    "WRX/STI GE/GH/GR/GV",
    "WRX/STI VA",
    "WRX VB",
    "LEGACY BM/BR",
    "FORESTER SG",
    "FORESTER SH",
    "FORESTER SJ",
    "VX GP",
    "VX GT",
  ],
  SCION: ["FR-S ZN6"],
  TOYOTA: [
    "GT86 ZN6", 
    "GR86 ZN8",
    "JZX90", 
    "JZX100", 
    "JZX110",
  ],
  BMW: [
    "E8X (1 Series)",
    "F2X (2 Series)",
    "E9X (3 Series)",
    "F3X (3 and 4 Series)",
    "F8X (M2/M3/M4)",
    "G8X (M3/M4)",
    "Z4 (G29)",
  ],
  LEXUS: [
    //"IS200 GXE10",
    "IS200 SXE10",
    "IS300 JCE10",
    "JZS161/GS300",
  ],
};

// Refresh the models dropdown when a make is selected.
function loadModels(value) {
  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject.myGarage ?? "[]");
  let selectModel = document.getElementById("modelDropdown");
  if (carModels[value] && carModels[value].length) {
    selectModel.innerHTML = "<option value>Select Make</option>";
    for (let i = 0; i < carModels[value].length; i++) {
      let option = document.createElement("option");
      option.value = carModels[value][i];
      option.text = carModels[value][i];
      if (myGarageArray.includes(value + " " + carModels[value][i])) {
        option.disabled = true;
      }
      selectModel.add(option);
    }
    selectModel.disabled = false;
  } else {
    selectModel.innerHTML = "<option value>Select Make</option>";
    selectModel.disabled = true;
  }
}

// Add to Garage button should only display when make and model are selected
function buttonActive() {
  const selectMake = document.getElementById("makeDropdown");
  const selectModel = document.getElementById("modelDropdown");
  const addBtn = document.getElementById("addGarage");
  document.getElementById(
    "fullModel"
  ).value = `${selectMake.value} ${selectModel.value}`;
  if (selectMake.value.length == 0 || selectModel.value.length == 0) {
    addBtn.disabled = true;
    addBtn.classList.add("button--ternary");
    addBtn.classList.remove("button--secondary");
  } else {
    addBtn.disabled = false;
    addBtn.classList.add("button--secondary");
    addBtn.classList.remove("button--ternary");
  }
}

// Lights. Camera. Action! After page loads, fire up the vehicle filter.
document.addEventListener("DOMContentLoaded", function () {
  refreshCookieArray();
});
// Reload myGarage when an AJAX reload happens
window.addEventListener("theme:loading:end", () => {
  refreshCookieArray();
});
